// extracted by mini-css-extract-plugin
module.exports = {"notFound":"NotFoundPage_notFound__1JRbJ"};